import React from "react";
import { CheckboxTick } from "../../../../public/IconComponents/CheckboxTick";

import {
    INPUT_CONTAINER,
    LABEL_CLASS,
    CHECK_BOX_CONTAINER,
    CHECK_BOX_INPUT,
    CUSTOM_BOX_CONTAINER,
} from "./constants";
import ErrorTextWithIcon from "../../Typography/ErrorTextWithIcon/ErrorTextWithIcon";

const NewCheckbox = ({
    errors,
    label,
    type = "checkbox",
    field,
    register = () => {},
    onChange,
    checked,
    locale,
}) => {
    return (
        <div className="pb-2">
            <div className={INPUT_CONTAINER}>
                <div className={CHECK_BOX_CONTAINER}>
                    <input
                        type={type}
                        className={CHECK_BOX_INPUT}
                        onChange={onChange}
                        {...register(field)}
                        checked={checked}
                    />
                    <div className={CUSTOM_BOX_CONTAINER}>
                        <CheckboxTick />
                    </div>
                    <p className={LABEL_CLASS}>{label}</p>
                </div>
                <div>
                    <ErrorTextWithIcon text={errors?.[field]?.message} />
                </div>
            </div>
        </div>
    );
};

export default NewCheckbox;
